import { useEffect } from 'react';

import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import { getRangeInlineNodeNames } from '@atlaskit/editor-common/utils';
import type { EditorState, SelectionBookmark } from '@atlaskit/editor-prosemirror/state';

import type { AnnotationPlugin } from '../../annotationPluginType';
import { resolveDraftBookmark } from '../../pm-plugins/utils';
import type { AnnotationSelectionType } from '../../types';
import type { AnnotationProviders } from '../../types';

import { fireCommentButtonViewedAnalyticsEvent } from './utils';

export const useCommentButtonMount = ({
	state,
	annotationProviders,
	api,
	annotationSelectionType,
	bookmark,
}: {
	annotationProviders?: AnnotationProviders;
	annotationSelectionType: AnnotationSelectionType;
	api?: ExtractInjectionAPI<AnnotationPlugin>;
	bookmark?: SelectionBookmark;
	state: EditorState | null | undefined;
}): void => {
	useEffect(() => {
		if (!state) {
			return;
		}

		if (annotationProviders?.inlineComment) {
			annotationProviders.inlineComment.onCommentButtonMount?.();
		}
		// Check if the selection includes an non-text inline node
		const inlineNodeNames =
			getRangeInlineNodeNames({
				doc: state.doc,
				pos: resolveDraftBookmark(state, bookmark),
			}) ?? [];

		const isNonTextInlineNodeInludedInComment =
			// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
			inlineNodeNames.filter((nodeName) => nodeName !== 'text').length > 0;

		fireCommentButtonViewedAnalyticsEvent({
			api,
			isNonTextInlineNodeInludedInComment,
			annotationSelectionType,
		});
		// for now trying to replicate current onMount logic
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
